import * as React from 'react';
import styled from 'styled-components';
import Lang from './lang';
import Flower from './flower';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 45px 25px;
  height: 100vh;
  z-index: 1;
`;

const PhotoFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  border: 2px solid #e1b949;

  & h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 90px;
    width: 100%;
    height: 240px;

    @media (max-width: 375px) {
      @media (max-width: 320px) {
        height: 200px;
      }
      @media (max-height: 600px) {
        margin-top: 50px;
      }
    }

    @media (min-width: 500px) and (orientation: landscape) {
      margin-top: 65px;
      height: 100px;
    }

    @media (max-width: 600px) and (orientation: landscape) {
      margin-top: 55px;
      height: 80px;
    }
  }
`;

interface StyleProps {
  who: string;
  lang?: string;
}

const LovePeople = styled.div<StyleProps>`
  position: absolute;
  top: 90px;
  ${props => (props.who === 'husband' ? 'left: 68px' : 'right: 68px')};
  width: 58px;
  height: 240px;
  font-size: 0;
  text-align: right;
  background: url(${props => (props.who === 'husband' ? require(`../../assets/intro/wedding_jun@2x_${props.lang}.png`) : require(`../../assets/intro/wedding_hee@2x_${props.lang}.png`))}) 0 0 no-repeat;
  background-size: 100%;
  z-index: 1;

  @media (max-width: 375px) {
    @media (max-width: 320px) {
      width: 48px; height: 200px;
      ${props => (props.who === 'husband' ? 'left: 48px' : 'right: 48px')};
    }

    @media (max-height: 600px) {
      top: 50px;
    }
  }

  @media (min-width: 500px) and (orientation: landscape) {
    top: 65px;
    ${props => (props.who === 'husband' ? 'left: 15%' : 'right: 15%')};
    width: 174px;
    height: 86px;
    background-image: url(${props => (props.who === 'husband' ? require(`../../assets/intro/wedding_jun_land@2x_${props.lang}.png`) : require(`../../assets/intro/wedding_hee_land@2x_${props.lang}.png`))});
  }

  @media (max-width: 600px) and (orientation: landscape) {
    top: 60px;
    ${props => (props.who === 'husband' ? 'left: 80px' : 'right: 80px')};
    width: 124px;
  }

  ${props => props.lang ==='en-US' && (`
    ${(props.who === 'husband' ? 'top: 50px; left: 20px;' : 'top: 235px; right: 20px;')};
    width: 174px !important;
    height: 86px !important;
    background-image: url(${(props.who === 'husband' ? require(`../../assets/intro/wedding_jun_land@2x_${props.lang}.png`) : require(`../../assets/intro/wedding_hee_land@2x_${props.lang}.png`))});
    background-size: auto 100% !important;
    ${(props.who !== 'husband' ? 'background-position: right 0;' : '')};


    @media (max-width: 375px) {
      @media (max-width: 320px) {
        width: 48px; height: 200px;
        ${props.who === 'husband' ? 'left: 20px' : 'right: 20px'};
      }

      @media (max-height: 600px) {
        ${props.who === 'husband' ? 'top: 50px' : 'top: 165px'};
      }
    }
    `
  )}
`;

const Heart = styled.div`
  display: flex;
  color: #aca8a2;
  font-size: 50px;

  @media (max-width: 600px) and (orientation: landscape) {
    font-size: 40px;
  }
`;

const DatePlace = styled.div`
  display: block;
  margin-top: 40px;
  line-height: 1.4;
  color: #6a6560;
  font-size: 15px;
  text-align: center;

  @media (min-width: 500px) and (max-width: 700px) and (orientation: landscape) {
    position: absolute;
    bottom: 20px;
    right: 20px;
    margin-top: 0;
    text-align: right;
  }
  @media (max-width: 320px) {

    @media (max-height: 550px) {
      margin-top: 20px;
    }
  }
`;

const WeddingDate = styled.strong`
  font-weight: normal;
`;
const Location = styled.address`
  display: block;
  letter-spacing: 1px;
`;

interface IProps {
  messages?: any;
  lang?: string;
}

const Intro = ({messages, lang} : IProps) => {

  return (
    <Wrap>
      <Lang lang={lang} />
      <PhotoFrame>
        <h1>
          <LovePeople lang={lang} who={'husband'}>{messages.husband[0]}{messages.husband[1]}</LovePeople>
          <Heart>&amp;</Heart>
          <LovePeople lang={lang} who={'wife'}>{messages.wife[0]}{messages.wife[1]}</LovePeople>
        </h1>
        <DatePlace>
          <WeddingDate>{messages.date}</WeddingDate>
          <Location>{messages.location}</Location>
        </DatePlace>
      </PhotoFrame>
      <Flower shape={'top'} />
      <Flower shape={'bottom'} />
    </Wrap>
  );
}

export default Intro;


// WEBPACK FOOTER //
// ./src/components/intro/index.tsx